<template>
    <span>
        <template v-if="appNotDownloaded">
            <el-popover
                placement="bottom-end"
                width="270"
                popper-class="el-caller"
                v-model="popoverState"
                @hide="defaultCallProvider">
                <CallSelect
                    :patient="patient"
                    :provider-profile-list="providerProfileList"
                    @provider-select="setCallProvider"
                    v-if="showMultiProviders && !callProvider">
                </CallSelect>
                <div class="action-wrapper" v-else>
                    <div class="provider-choice" v-if="showMultiProviders && callProvider">
                        <span>
                            <b>{{ getProviderNameById(callProvider.provider) }} </b><br/>
                            ({{ getContentKey('profile', callProvider.profile, 'title') }})
                        </span>
                        <span class="change-provider" @click="callProvider = null">
                            Change
                        </span>
                    </div>
                    <el-button type="primary" class="primary"
                        @click="openDialog('reminder')">
                        Send Reminder to Download App
                    </el-button>
                    <el-button type="text" @click="popoverState = false">
                        Cancel
                    </el-button>
                </div>
                <el-tooltip :disabled="popoverState" effect="dark" content="App not installed" placement="bottom" slot="reference">
                    <el-button
                        class="popover-button" 
                        type="text">
                        <VideoRed ></VideoRed>
                    </el-button>
                </el-tooltip>
            </el-popover>
        </template>
        <template v-else-if="permissionNotGiven">
            <el-popover
                placement="bottom-end"
                width="250"
                popper-class="el-caller"
                v-model="popoverState"
                @hide="defaultCallProvider">
                <CallSelect
                    :patient="patient"
                    :provider-profile-list="providerProfileList"
                    @provider-select="setCallProvider"
                    v-if="showMultiProviders && !callProvider">
                </CallSelect>
                <div class="action-wrapper" v-else>
                    <div class="provider-choice" v-if="showMultiProviders && callProvider">
                        <span>
                            <b>{{ getProviderNameById(callProvider.provider) }} </b><br/>
                            ({{ getContentKey('profile', callProvider.profile, 'title') }})
                        </span>
                        <span class="change-provider" @click="callProvider = null">
                            Change
                        </span>
                    </div>
                    <el-button type="primary" class="permission"
                        @click="openDialog('permission')">
                        <Permission></Permission>
                        Ask for Video Permissions
                    </el-button>
                    <el-button type="success"
                        @click="openMeeting">
                        <VideoStart></VideoStart>
                        Place Video Call
                    </el-button>
                    <el-button type="text" @click="popoverState = false">
                        Cancel
                    </el-button>
                </div>
                <el-tooltip :disabled="popoverState" effect="dark" content="Video Call" placement="bottom" slot="reference">
                    <el-button
                        class="popover-button" 
                        type="text">
                        <VideoGrey></VideoGrey>
                    </el-button>
                </el-tooltip>
                
            </el-popover>
        </template>
        <template v-else>
            <el-popover
                placement="bottom-end"
                width="250"
                popper-class="el-caller"
                v-model="popoverState"
                @hide="defaultCallProvider">
                <CallSelect
                    :patient="patient"
                    :provider-profile-list="providerProfileList"
                    @provider-select="setCallProvider"
                    v-if="showMultiProviders && !callProvider">
                </CallSelect>
                <div class="action-wrapper" v-else >
                    <div class="provider-choice" v-if="showMultiProviders && callProvider">
                        <span>
                            <b>{{ getProviderNameById(callProvider.provider) }} </b><br/>
                            ({{ getContentKey('profile', callProvider.profile, 'title') }})
                        </span>
                        <span class="change-provider" @click="callProvider = null">
                            Change
                        </span>
                    </div>
                    <el-button type="success" class="primary"
                        @click="openMeeting">
                    Call {{ patient.name }}
                    </el-button>
                    <el-button type="text" @click="popoverState = false">
                        Cancel
                    </el-button>
                </div>
                <el-tooltip :disabled="popoverState" effect="dark" content="Video Call" placement="bottom" slot="reference">
                    <el-button
                        class="popover-button" 
                        type="text">
                        <VideoGreen></VideoGreen>
                    </el-button>
                </el-tooltip>
            </el-popover>
        </template>
        <CallDialog
            :patient="patient"
            :provider-id="callProvider ? callProvider.provider : ''"
            :show-dialog="showDialog"
            :dialog-type="dialogType"
            @close="showDialog = false"></CallDialog>
    </span>
</template>

<script>
import semverCompare from 'semver-compare'
import Icons from './icon/index'
import CallDialog from './CallDialog'
import CallSelect from './call/CallSelect'
import { mapGetters } from 'vuex'

/**
 * Patient call options for
 * different conditions for patients
 * @component
 */
export default {
    name: 'patient-call',

    data() {
        return {
            /**
             * Should popover be open or not
             */
            popoverState: false,
            /**
             * Should dialog be visible or not
             */
            showDialog: false,
            /**
             * Type of dialog to be opened
             * @values permission, reminder
             */
            dialogType: 'permission',
            /**
             * Provider id for which call would have to be placed
             */
            callProvider: (this.providerProfileList.length == 1) ? this.providerProfileList[0] : null
        }
    },

    props: {
        patient: {
            type: Object,
            required: true
        },
        providerProfileList: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    methods: {
        /**
         * Open the video call in a new tab
         */
        openMeeting() {
            this.popoverState = false;
            let callProvider = this.callProvider
            if(this.allPatientsChosen && !callProvider && this.providerProfileList.length === 1)
                callProvider = this.providerProfileList[0]
            window.open(`/meeting/${this.patient.id}?name=${this.patient.name}` + (callProvider ? ('&provider=' + callProvider.provider) : ''), '_blank')
        },
        /**
         * Opens the dialog box for asking permissions
         * or sending reminder to download app
         * @param {String} dialogType The type of dialog `permission` or `reminder`
         */
        openDialog(dialogType) {
            this.dialogType = dialogType
            this.showDialog = true
        },
        setCallProvider(providerObj) {
            this.callProvider = providerObj
        },
        defaultCallProvider() {
            setTimeout(() => {
                if(this.providerProfileList.length > 1)
                    this.callProvider = null
            }, 200)
        }
    },

    computed: {
        ...mapGetters('provider', [
            'allPatientsChosen',
            'getProviderNameById'
        ]),
        ...mapGetters('content', [
            'getContentKey'
        ]),
        /**
         * Checks if mobile app donwloaded by patient or 
         * not updated
         */
        appNotDownloaded() {
            const iosMinVersion = '4.3.0',
                androidMinVersion = '4.1.0'
            let iosCallable = false, androidCallable = false
            if(this.patient.ios_version)
                iosCallable = semverCompare(this.patient.ios_version, iosMinVersion) !== -1
            if(this.patient.android_version)
                androidCallable = semverCompare(this.patient.android_version, androidMinVersion) !== -1

            return !iosCallable && !androidCallable
        },
        /**
         * Check if permisssions not given for camera or microphone
         */
        permissionNotGiven() {
            return this.patient.camera_disabled || this.patient.microphone_disabled
        },
        showMultiProviders() {
            return this.allPatientsChosen && (this.providerProfileList.length > 1)
        }
    },

    components: {
        ...Icons,
        CallDialog,
        CallSelect
    }
}
</script>


<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.action-wrapper {
    display: flex;
    flex-direction: column;
    padding: 12px;
    .el-button {
        font-size: 14px;
        padding: 8px 20px;
        margin-left: 0;
        border: none;
        svg {
            vertical-align: sub;
        }
    }
    .el-button--text {
        font-size: 12px;
        color: $dark-grey;
        padding-bottom: 0px;
        margin-top: 5px;
    }
    .permission {
        margin-bottom: 12px;
        background-color: $activity-blue;
    }
    .provider-choice {
        display: flex;
        color: $grey-700;
        font-size: 14px;
        margin-bottom: 10px;
        span{
            flex-grow: 1;
        }
        b {
            color: $black-color;
        }
        .change-provider {
            font-size: 12px;
            color: #117dfb;
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
.popover-button {
    padding: 0;
    vertical-align: middle;
    margin-right: 5px;
}
</style>
<style lang="scss">
.el-caller.el-popover {
    padding: 0;
}
</style>